import {
  DEFAULT_LEADS_FUNNEL_MAX_VISIBLE_COLUMNS,
  DEFAULT_LEADS_LOAD_BATCH_SIZE,
  LEADS_FUNNEL_MAX_VISIBLE_COLUMNS,
  LEADS_FUNNEL_MIN_VISIBLE_COLUMNS,
  LEADS_REGISTRY_LOAD_BATCH_SIZE_OPTIONS,
  MIN_LEADS_PORTION_SIZE,
} from '../model/constants';

import type { LeadsRegistryLoadBatchSize } from '../model/types';

export const normalizeLeadsPortionSize = (
  portionSize: number | null | undefined
): number => {
  if (!portionSize || portionSize < MIN_LEADS_PORTION_SIZE) {
    return MIN_LEADS_PORTION_SIZE;
  }

  return portionSize;
};

export const normalizeLeadsLoadBatchSize = (
  portionSize: number | null | undefined
): LeadsRegistryLoadBatchSize => {
  const normalizedPortionSize = normalizeLeadsPortionSize(portionSize);

  return LEADS_REGISTRY_LOAD_BATCH_SIZE_OPTIONS.includes(
    normalizedPortionSize as LeadsRegistryLoadBatchSize
  )
    ? (normalizedPortionSize as LeadsRegistryLoadBatchSize)
    : DEFAULT_LEADS_LOAD_BATCH_SIZE;
};

export const normalizeLeadsFunnelMaxVisibleColumns = (
  value: number | null | undefined
): number => {
  if (typeof value !== 'number' || !Number.isFinite(value)) {
    return DEFAULT_LEADS_FUNNEL_MAX_VISIBLE_COLUMNS;
  }

  const rounded = Math.round(value);

  return Math.min(
    LEADS_FUNNEL_MAX_VISIBLE_COLUMNS,
    Math.max(LEADS_FUNNEL_MIN_VISIBLE_COLUMNS, rounded)
  );
};
